export { cn } from '@repo/ux/lib/utils';

/**
 * Guards `next/image` against unparseable CMS/seed values (e.g. "not image").
 * next/image throws at render time on invalid src, so validate before render —
 * onError alone cannot catch it.
 */
export const isValidImageSrc = (src?: string | null): src is string =>
  !!src &&
  (src.startsWith('/') ||
    src.startsWith('http://') ||
    src.startsWith('https://'));
